<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap v-if="model">
            <v-flex xs12>
                <material-card>
                    <v-form>
                        <v-container fill-height fluid grid-list-xl>
                            <v-layout wrap style="background: #fff;" class="borderTop">
                                <v-flex md2 sx2 class="conTh py-2 borderBottom ">ID</v-flex>
                                <v-flex md4 sx4 class="py-2 borderBottom  borderRight">{{model.id}}</v-flex>

                                <v-flex md2 xs2 class="conTh py-2 borderBottom">게시상태</v-flex>
                                <v-flex md4 sx4 class="py-2 borderBottom  borderRight">
                                    <v-select
                                            v-model="model.posting_yn"
                                            :items="OPTIONS_OPEN_STATUS.slice(1,OPTIONS_OPEN_STATUS.length)"
                                            label=""
                                            flat
                                            hide-details
                                            solo
                                            :disabled="permission > 2?false:true"
                                    ></v-select>
                                </v-flex>

                                <v-flex md2 xs2 class="conTh py-2 borderBottom">게시일자</v-flex>
                                <v-flex md4 sx4 class="py-2 borderBottom  borderRight">{{model.created_at | time}}</v-flex>
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">변경일시</v-flex>
                                <v-flex md4 sx4 class="py-2 borderBottom  borderRight">{{model.updated_at | time}}</v-flex>
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">제목</v-flex>
                                <v-flex md10 sx10 class="py-2 borderBottom  borderRight">
                                    <v-text-field
                                            v-model="model.title"
                                            label="제목"
                                            flat
                                            solo
                                            hide-details
                                            :disabled="permission > 2?false:true"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md2 xs2 class="conTh py-2 borderBottom">내용</v-flex>
                                <v-flex md10 xs10 class="pa-2  borderRight borderBottom">
                                    <div class="detailInfo ">
                                        <editor api-key='40gjhoe9qw4arr3ts44g2km7b2h1fli0elf1ymr6dh2k1mhb'
                                                cloud-channel='dev' :init="editorConfig"
                                                v-model="model.content"
                                                :disabled="permission > 2?false:true"
                                        ></editor>
                                    </div>
                                </v-flex>

                                <v-flex md12 class="text-xs-center">
                                    <v-pagination v-model="pagination.page" :length="pages" :total-visible="10"></v-pagination>
                                </v-flex>

                                <v-flex xs12 text-xs-right>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="remove()"  v-if="permission > 3">삭제</v-btn>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="goList()"  v-else>목록</v-btn>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="cancel()" v-if="permission > 2">취소</v-btn>
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" @click="save()" v-if="permission > 2">저장</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import MyMixinList from '../../mixins/MyMixinList'
	import MyMixinCommon from '../../mixins/MyMixinCommon';
	import { mapActions, mapGetters } from 'vuex'
	import Editor from '@tinymce/tinymce-vue';

	import * as noticeApi from '../../service/api/notice-api'
    import {Notice} from "../../service/model/Notice";


	export default {
		mixins: [ MyMixinCommon, MyMixinList ],
		components: {
			'editor': Editor,
		},

		data: () => ({
			id: null,
			model: new Notice(),
			posting_status: [ '게시', '게시중지' ],
			items: [],
		}),
		created() {
            // 권한체크
            this.permissionCheck()

		},
		computed: {
			pages() {
				if( this.pagination.rowsPerPage == null ||
					this.pagination.totalItems == null
				) return 0

				return Math.ceil( this.pagination.totalItems / this.pagination.rowsPerPage )
			}

		},
		methods: {
			...mapGetters( 'user', [ 'getUserId','getLoginType' ] ),

			/////////////////////////////////////////////////// INIT /////////////////////////////////////////////////////////

            permissionCheck(){
                if(Number(this.getLoginType())  >= 3) {

                    if(this.$route.params.id)
                    {
                        this.id = this.$route.params.id


                        // 라우트 지
                        if( this.$route.params.id ) {
                            this.id = this.$route.params.id
                        } else {
                            this.id = '1'
                        }

                        this.reqContents()
                    }
                }else{

                    this.$dialog.alert('관리자 권한이 없어 메인페이지로 이동합니다.').then(dialog=>{
                        this.$router.push( 'contents' )
                    })
                }
            },
			init() {


				//1. api 확인 - 포스트맨 ( 정상)
				//2. 모델 생성
				//3. API 함수 생성 - get,post, put, delete
				//4. api 임포트, api 호출
				//5. 데이터 바인딩

			},


			/////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////


			save() {
				if( ! this.model.title ) {
					this.$dialog.alert( '제목을 입력해주세요.' )
					return;
				}

				if( ! this.model.content ) {
					this.$dialog.alert( '내용를 입력해주세요.' )
					return;
				}

				let data = {
					title: this.model.title,
					content: this.model.content,
					category: this.model.category,
                    posting_yn: this.model.posting_yn,
					tags: this.model.tags
				}

				this.$dialog.confirm( '저장 하시겠습니까?' )
				.then( dialog => {
					this.reqModifyNotice(data)
				} )
				.catch( function() {
				} )


			},
			remove( ) {
				this.$dialog.confirm( '삭제 하시겠습니까?' )
				.then( dialog => {
					this.reqRemoveNotice()
				} )
				.catch( function() {
				} )

			},
			cancel() {
				this.$router.back()
			},
			removeTag( item ) {
				if( this.model.tag ) {
					this.model.tag.splice( this.model.tag.indexOf( item ), 1 )
					this.model.tag = [ ...this.model.tag ]
				}

			},

			goList() {
				this.$router.replace( { name: 'notices' } );
			},

			/////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////

			reqContents() {

				return noticeApi.findNotice( this.id ).then( res => {

					console.log( `Log ${this.$options.name} res = ${JSON.stringify( res.data, null, 2 )}` )
					if( res.data ) {
						this.model = res.data

						if( this.model.posting_yn ) {
							this.model.posting_yn = '1'
						} else {
							this.model.posting_yn = '0'
						}

						// 자기가 쓴 글일 경우 퍼미션 변경
                        if(res.data.user_id == this.getUserId())
                        {
                        	this.permission = 4
                        }
					}
				} ).catch( e => {

                    if(e.code == '601'){
	                    this.$dialog.alert( e.message ).then(dialog=>{
		                    this.$router.replace( { name: 'notices' } );
	                    })
                    }else{
	                    this.$dialog.alert( e.message )
                    }

				} )

			},

			reqModifyNotice(data) {

				return noticeApi.modifyNotice( data, this.model.id ).then( res => {
					this.goList()

				}).catch(e=>{
					this.$dialog.alert(e.message)
				})
            },

			reqRemoveNotice() {

				return noticeApi.removeNotice( this.model.id ).then( res => {

					if( res.data.affected_rows == '1' ) {
						this.goList()
					}
				}).catch(e=>{
					this.$dialog.alert(e.message)
				})
            },
		},
	}

</script>
